const mediaQuery=window.matchMedia('(max-width: 750px)')
const fixedCart=document.querySelector('.fixed-atc')
const cartTrigger=document.querySelector('.trigger__fixed--cart')
const fixedCartID=document.getElementById('fixed--cart')
const arrow=document.getElementById('arrow--up')
const hiddenSwatch=document.getElementById('hidden--swatches')
const optionLabel=document.getElementById('color--label')
if(mediaQuery.matches){const thresholdArray=steps=>Array(steps+1).fill(0).map((_,index)=>index / steps||0)
let previousY=0
let previousRatio=0
const handler=(entries)=>{entries.forEach(entry=>{const currentY=entry.boundingClientRect.y
const currentRatio=entry.intersectionRatio
const isIntersecting=entry.isIntersecting
if(currentY<previousY){if(currentRatio>previousRatio&&isIntersecting){fixedCartID.classList.remove('enabled')
fixedCartID.classList.remove('fixed-atc')
hiddenSwatch.classList.add('hidden--swatches')}else{fixedCartID.classList.add('fixed-atc')
fixedCartID.classList.add('enabled')
arrow.classList.remove('hidden')
optionLabel.classList.add('hidden')}}else if(currentY>previousY&&isIntersecting){if(currentRatio<previousRatio){fixedCartID.classList.add('fixed-atc')
fixedCartID.classList.add('enabled')}else{fixedCartID.classList.remove('enabled')
fixedCartID.classList.remove('fixed-atc')
hiddenSwatch.classList.remove('hidden--swatches')
arrow.classList.add('hidden')
optionLabel.classList.remove('hidden')}}
previousY=currentY
previousRatio=currentRatio});}
const observer=new IntersectionObserver(handler)
observer.observe(cartTrigger)}